import { createFileRoute } from "@tanstack/react-router";
import AdminFAQ from "@/pages/admin/AdminFAQ";

export const Route = createFileRoute("/admin/faq")({
  component: AdminFAQ,
});
